import { render, staticRenderFns } from "./HighAnalitycsDashboard.vue?vue&type=template&id=a80e734a&scoped=true"
import script from "./HighAnalitycsDashboard.vue?vue&type=script&lang=js"
export * from "./HighAnalitycsDashboard.vue?vue&type=script&lang=js"
import style0 from "./HighAnalitycsDashboard.vue?vue&type=style&index=0&id=a80e734a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80e734a",
  null
  
)

export default component.exports